<template>
	<i class="symbol help left">
		<object
			tabindex="-1"
			type="image/svg+xml"
			data="/static/build/gfx/svg/symbol-error.svg"
		/>

		<object
			class="help-hover"
			tabindex="-1"
			type="image/svg+xml"
			data="/static/build/gfx/svg/symbol-error-hover.svg"
		/>
	</i>
</template>
